import { useEffect } from 'react';
import { useHistoryPreview as useHistoryPreviewState } from 'components/core/History';
import { useLazyCategoryHistoryQuery } from 'services/admin-bff-sdk/generated';
import { prepareCategoryHistoryData } from './helpers';
import type { CategoryHistoryData } from './types';

export function useGetCategoryHistoryData(provider: string, categoryId: number, isExpanded: boolean) {
    const [getCategoryHistory, { data, isFetching, isError }] = useLazyCategoryHistoryQuery();

    // Unlike an asset, a category has no `updated` field to key a refetch on. History records
    // are also written out of band by an AMQP consumer after the API responds, so refetching on
    // submit would usually return the pre-save state. Every expand refetches instead.
    useEffect(() => {
        if (isExpanded) {
            getCategoryHistory({ newsroom: provider, categoryId });
        }
    }, [isExpanded, provider, categoryId, getCategoryHistory]);

    const historyData = prepareCategoryHistoryData(data?.categoryHistory);

    // isLoading is only true on the very first fetch; since every expand refetches, isFetching
    // is what keeps the spinner (rather than stale data) showing on subsequent re-expands
    return { historyData, isLoading: isFetching, isError };
}

export function useHistoryPreview() {
    return useHistoryPreviewState<CategoryHistoryData>();
}
